import React from "react";

const tocItems = [
  { id: "what-is-house-rent-tax", label: "What is the House Rent Tax?" },
  {
    id: "where-do-you-pay",
    label: "Where Do You Pay? (The Supreme Court Rule)",
  },
  {
    id: "corporate-tenant-pitfall",
    label: "The Corporate Tenant Pitfall: Who Actually Pays?",
  },
  {
    id: "fines-penalties",
    label: "Fines, Penalties, and Early Bird Discounts",
  },
  { id: "essential-documents", label: "Essential Documents for Filing" },
  { id: "faqs", label: "Frequently Asked Questions (FAQs)" },
];

export default function BlogTOC() {
  return (
    <nav
      className="blog-toc"
      style={{
        margin: "1.5rem 0 2.5rem 0",
        background: "var(--bg)",
        borderRadius: 10,
        padding: "1.2rem 1rem",
        boxShadow: "var(--shadow-xs)",
      }}
    >
      <div
        style={{ fontWeight: 700, color: "var(--sky-700)", marginBottom: 8 }}
      >
        Table of Contents
      </div>
      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
        {tocItems.map((item) => (
          <li key={item.id} style={{ marginBottom: 6 }}>
            <a
              href={`#${item.id}`}
              style={{
                color: "var(--sky-700)",
                textDecoration: "none",
                fontWeight: 500,
              }}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
